// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../../actions';

// REACT ROUTER
import { Link, NavLink } from 'react-router-dom';

// UTILS
import { constants } from '../../constants/index';
import { ShowWidth } from '../ShowWidth';
import { HideWidth } from '../HideWidth';

// MATERIAL UI
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconButton from 'material-ui/IconButton';

/*

Props:
• style

*/

class ToolbarSearchComponent extends Component {

	constructor(props) {
		super(props);
		this.state = { 
			height: '0',
			initHide: false,
			initShow: true,
			loginDialogOpen: false,
			menuAnchorElement: null,
			menuOpen: false,
			value: 1,
			width: '0', 
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({ 
			height: window.innerHeight,
			width: window.innerWidth, 
		});
	}

	handleNestedMenuClick = (event) => {
		// This prevents ghost click.
		event.preventDefault();
	
		this.setState({
			menuAnchorElement: event.currentTarget,
			menuOpen: true,
		});
	  };

	  handleMenuClose = () => {
		this.setState({
			menuOpen: false
		})
	}

	render = () => {
		const childNum = React.Children.count(this.props.children);

		return (
			<div ref="toolbar">
				<ShowWidth width={this.props.mediaQ1 + 1}>
					<IconButton onClick={this.handleNestedMenuClick}><MoreVertIcon color='gray'/>
						<Popover
							open={this.state.menuOpen}
							anchorEl={this.state.menuAnchorElement}
							anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
							targetOrigin={{horizontal: 'left', vertical: 'top'}}
							onRequestClose={this.handleMenuClose}
							animation={PopoverAnimationVertical}
						>
							<Menu>
								{ (childNum > 0) && React.Children.map(this.props.children, (child, i) => {
									return (
										<MenuItem 
											value={i}
										>
											{child}
										</MenuItem>
									);
								})}
								{/* {this.props.children} */}
							</Menu>
						</Popover>
					</IconButton>
				</ShowWidth>
				
				<HideWidth width={this.props.mediaQ1}>
					<div style={{display: 'Flex', flexDirection: 'row', alignItems: 'center'}}>
						{ (childNum > 0) && React.Children.map(this.props.children, ( child, i) => {
							return (
								<div>
									{child}
								</div>	
							);
						})}
					</div>	
				</HideWidth>
			</div>
		);
	}
};

const mapStateToProps = ({auth}) => ({
	userId: (auth.authData) ? auth.authData.id : null
});

const ToolbarSearch = connect(mapStateToProps, actions)(ToolbarSearchComponent);
export { ToolbarSearch as default }



// WEBPACK FOOTER //
// ./src/js/components/ToolbarSearch/ToolbarOptionsDisplay.jsx